/**
 * Driver
 * @author Thacryba
 */
import {Resource} from 'simpli-web-sdk'

export class Driver extends Resource {
  idDriverPk: number = 0

  creationDate: string | null = null

  document: string | null = null
  name: string | null = null
  telephone: string | null = null
  active: boolean | null = null

  get $id() {
    return this.idDriverPk
  }
  set $id(val) {
    this.idDriverPk = val
  }
  get $tag() {
    return String(this.name)
  }
}
